var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withForwardedRef } from '../utils/helpers/reactHelpers';
const preparePropertyFor = (property, propertyDirection, p) => {
    if (p[property] || p[property] === 0) {
        return `${p[property] * parseFloat(p.theme.SizeSpacingDefault)}rem`;
    }
    if (p[propertyDirection] || p[propertyDirection] === 0) {
        return `${p[propertyDirection] * parseFloat(p.theme.SizeSpacingDefault)}rem`;
    }
    return '';
};
const prepareBreakpointPropertyFor = (property, propertyShortHand, p) => {
    const breakPointsMap = {
        xs: `@media (min-width: ${parseInt(p.theme.SizeBreakpointsXs, 10)}px) and (max-width: ${parseInt(p.theme.SizeBreakpointsS, 10) - 1}px)`,
        s: `@media (min-width: ${parseInt(p.theme.SizeBreakpointsS, 10)}px) and (max-width: ${parseInt(p.theme.SizeBreakpointsM, 10) - 1}px)`,
        m: `@media (min-width: ${parseInt(p.theme.SizeBreakpointsM, 10)}px) and (max-width: ${parseInt(p.theme.SizeBreakpointsL, 10) - 1}px)`,
        l: `@media (min-width: ${parseInt(p.theme.SizeBreakpointsL, 10)}px) and (max-width: ${parseInt(p.theme.SizeBreakpointsXl, 10) - 1}px)`,
        xl: `@media (min-width: ${parseInt(p.theme.SizeBreakpointsXl, 10)}px)`
    };
    let propertyCss = '';
    Object.keys(breakPointsMap).forEach((breakPoint) => {
        const propertyPassed = p[`${breakPoint}-${propertyShortHand}`];
        if (Number.isFinite(propertyPassed)) {
            propertyCss = `${propertyCss}
        ${breakPointsMap[breakPoint]} {
          ${property} : ${propertyPassed * parseFloat(p.theme.SizeSpacingDefault)}rem
        }
      `;
        }
    });
    return propertyCss;
};
const BoxSC = styled.div `
  display: ${(props) => props.displayBox || 'block'};

  margin: ${(props) => preparePropertyFor('m', '', props)};

  margin-top: ${(props) => preparePropertyFor('mt', 'my', props)};
  margin-right: ${(props) => preparePropertyFor('mr', 'mx', props)};
  margin-bottom: ${(props) => preparePropertyFor('mb', 'my', props)};
  margin-left: ${(props) => preparePropertyFor('ml', 'mx', props)};

  padding: ${(props) => preparePropertyFor('p', '', props)};

  padding-top: ${(props) => preparePropertyFor('pt', 'py', props)};
  padding-right: ${(props) => preparePropertyFor('pr', 'px', props)};
  padding-bottom: ${(props) => preparePropertyFor('pb', 'py', props)};
  padding-left: ${(props) => preparePropertyFor('pl', 'px', props)};

  ${(props) => prepareBreakpointPropertyFor('margin-top', 'mt', props)}
  ${(props) => prepareBreakpointPropertyFor('margin-right', 'mr', props)}
  ${(props) => prepareBreakpointPropertyFor('margin-bottom', 'mb', props)}
  ${(props) => prepareBreakpointPropertyFor('margin-left', 'ml', props)}

  ${(props) => prepareBreakpointPropertyFor('padding-top', 'pt', props)}
  ${(props) => prepareBreakpointPropertyFor('padding-right', 'pr', props)}
  ${(props) => prepareBreakpointPropertyFor('padding-bottom', 'pb', props)}
  ${(props) => prepareBreakpointPropertyFor('padding-left', 'pl', props)}


`;
const Box = (props) => {
    const { children, forwardedRef } = props, rest = __rest(props, ["children", "forwardedRef"]);
    return (React.createElement(BoxSC, Object.assign({}, rest, { ref: forwardedRef }), children));
};
Box.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    forwardedRef: PropTypes.any,
    m: PropTypes.number,
    mt: PropTypes.number,
    mr: PropTypes.number,
    mb: PropTypes.number,
    ml: PropTypes.number,
    mx: PropTypes.number,
    my: PropTypes.number,
    p: PropTypes.number,
    pt: PropTypes.number,
    pr: PropTypes.number,
    pb: PropTypes.number,
    pl: PropTypes.number,
    px: PropTypes.number,
    py: PropTypes.number,
    className: PropTypes.string,
    displayBox: PropTypes.oneOf(['inline', 'block', 'inline-block'])
};
Box.defaultProps = {
    children: null,
    forwardedRef: null,
    m: undefined,
    mt: undefined,
    mr: undefined,
    mb: undefined,
    ml: undefined,
    mx: undefined,
    my: undefined,
    p: undefined,
    pt: undefined,
    pr: undefined,
    pb: undefined,
    pl: undefined,
    px: undefined,
    py: undefined,
    className: undefined,
    displayBox: 'block'
};
export { Box as BoxRootComp };
export default withForwardedRef(Box);
//# sourceMappingURL=Box.js.map